import WhyChoosePoints from "./WhyChoosePoints";
import WhyChooseImage from "../../assets/images/why_choose_feature_image.png"
import Button from "../Buttons";

const WhyChoose = () => {
    return (

        <section id="why_choose_us">
            <div className="flex flex-col md:flex-row">
                <div className="layout-container lg:!pl-40 !py-1 md:!py-10">
                    <div>
                        <h2 className="text-[28px] md:text-[56px] font-semibold leading-[60px] mb-5 lg:mb-8">Why choose TalentHub?</h2>
                    </div>
                    <div className="flex flex-col gap-8 md:w-[93%]">
                        <WhyChoosePoints
                            title="Save Time, Work Smarter"
                            description="Skip reading endless resumes—video profiles let you assess candidates in minutes, cutting down the time spent on interviews by 50%. See the person behind the resume from the very first step."
                        />
                        <WhyChoosePoints
                            title="Convenient and Flexible"
                            description="Watch candidate videos anytime, anywhere, making decisions more convenient for you and your team. Share and evaluate profiles together, wherever it suits you."
                        />
                        <WhyChoosePoints
                            title="Showcase Skills and Personality from the Start"
                            description="TalentHub gives you a comprehensive view of candidates, highlighting both their skills and personality before the interview stage."
                        />
                        <WhyChoosePoints
                            title="Branded Experience"
                            description="Present candidates under your agency’s branding, ensuring your business stays front and center throughout the hiring process."
                        />

                        <Button
                            btn_label="Talk with our sales person"
                            on_click_handler={() => { }}
                            other_classes="!bg-[#23FF9C] mt-[-10px] lg:!w-56 !text-[#232323] !text-[14px]"
                        />

                    </div>
                </div>
                <div className="bg-[#E0EDE5] hidden lg:flex items-center w-full">
                    <img src={WhyChooseImage} alt="why_choose_image" className="ml-5" />
                </div>
            </div>
        </section>

    )
}

export default WhyChoose;